import { Card, Divider, Space } from "antd";
import { useOutletContext, useParams } from "react-router";
import AssignAppDomainSteps from "../../components/settings/AssignAppDomainSteps";
import MessageCard from "../../components/MessageCard";
import { IAppDetails } from "../../types";

const AppSettingsCustomDomain = () => {
    const { envId } = useParams();
    const { appDetails } = useOutletContext<{ appDetails: IAppDetails }>();

    return (
        <Space direction="vertical" className="full-width">
            {appDetails.clusterType === "shared" || !!appDetails.associatedNamespace ?
                <Card>
                    <Card.Meta
                        title="Assign domain"
                        description={`Domain configuration is not enabled for apps deployed on a ${appDetails.clusterType === "shared" ? "shared cluster" : "cluster with access limitation"}`}
                    />
                </Card> :
                <Card>
                    <Card.Meta
                        title="Assign domain"
                        description={
                            <>
                                In order to enable external access from the Internet to your deployed application, you need to assign a domain.<br />
                                If you have already configured a domain, you may change it here.
                            </>
                        }
                    />
                    <Divider />
                    {
                        appDetails.isDomainWorking ?
                            <MessageCard
                                type="domain-info"
                                style={{ marginBottom: 30 }}
                                text={
                                    <div>
                                        <div style={{ fontWeight: 600 }}>
                                            Your application is exposed on <a href={`https://${appDetails.domain}`} target="_blank" rel="noreferrer">{appDetails.domain}</a>
                                        </div>
                                        <div>
                                            If you want to change the domain, follow the steps below.
                                        </div>
                                    </div>
                                }
                                displayExclamationIcon={false}
                            />
                            : null
                    }
                    <AssignAppDomainSteps
                        envId={envId!}
                        appDetails={appDetails}
                        updateDomainEnabled={true}
                    />
                </Card>
            }
        </Space>
    );
}

export default AppSettingsCustomDomain;